import { emptySplitApi } from './index'

export const organizationProfileApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    insertAdditionalEmail: builder.mutation({
      query: (newEmailAddress) => ({
        url: `api/v1/auth-service/organization/profile/additional-email/${newEmailAddress}`,
        method: "POST"
      }),
    }),
    getOrganizationProfile: builder.mutation({
      query: () => ({
        url: `api/v1/auth-service/organization/profile`,
        method: "GET"
      }),
    }),
    getEmailsNotification: builder.mutation({
      query: () => ({
        url: `api/v1/auth-service/organization/profile/emails-notification`,
        method: "GET",
          
      }),
    }),
    updateOrganizationProfile: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/organization/profile`,
        method: "PATCH",
        body: model
      }),
      invalidatesTags: (result, error) => (error ? [] : ["OrganizationInfo"]),
    }),
    updateOrganizationOtherInfo: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/organization/profile/other-info`,
        method: "POST",
        body: model
      }),
      invalidatesTags: ["OrganizationInfo"],
    }),
    getOrganizationOtherInfo: builder.query({
      query: () => `api/v1/auth-service/organization/profile/other-info`,
      method: "GET",
      providesTags: ["OrganizationInfo"]
    }),
    getSubscriptionInfo: builder.query({
      query: (model) => ({
        url: `api/v1/auth-service/organization/profile/subscription-info`,
        method: "GET"
      }),
    }),
    sendRenewNotification: builder.mutation({
      query: (model) => ({
        url: `api/v1/auth-service/organization/profile/renew-notification`,
        method: "POST"
      }),
    }),
    getOnboardingPopupRemainder: builder.mutation({
      query: () => ({
        url: `api/v1/auth-service/organization/profile/popup-remainder`,
        method: "GET"
      }),
    }),
    saveOnboardingPopupRemainder: builder.mutation({
      query: (notShowAgain) => ({
        url: `api/v1/auth-service/organization/profile/popup-remainder/${notShowAgain}`,
        method: "PATCH"
      }),
    }),
  }),
  overrideExisting: false,
});

export const { 
  useInsertAdditionalEmailMutation,
  useGetOrganizationProfileMutation, 
  useUpdateOrganizationProfileMutation, 
  useGetEmailsNotificationMutation,
  useGetSubscriptionInfoQuery,
  useSendRenewNotificationMutation,
  useUpdateOrganizationOtherInfoMutation,
  useGetOrganizationOtherInfoQuery,
  useLazyGetOrganizationOtherInfoQuery,
  useGetOnboardingPopupRemainderMutation,
  useSaveOnboardingPopupRemainderMutation
} = organizationProfileApi;
